import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { OccEndpointsService } from '@spartacus/core';
import { of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';

import { customParameterActions } from '@app/core/store/custom-parameter/custom-parameter.actions';
import { CustomParameterResponse } from '@app/core/store/custom-parameter/custom-parameter.type';

@Injectable()
export class DpCustomParameterEffects {
  loadCustomParameters$ = createEffect(
    (
      actions$ = inject(Actions),
      http = inject(HttpClient),
      occEndpoints = inject(OccEndpointsService)
    ) =>
    actions$.pipe(
      ofType(customParameterActions.loadCustomParameters),
      switchMap(() => {
        const url = occEndpoints.buildUrl('customParameterBatch');
        return http.get<CustomParameterResponse>(url).pipe(
          map(response => customParameterActions.loadCustomParametersSuccess({ parameters: response.parameters })),
          catchError(error => of(customParameterActions.loadCustomParametersFailure({ error: error.message })))
        );
      })
    )
  );
}
